"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NoScript;

var _react = _interopRequireDefault(require("react"));

/**
 * A simple wrapper for HTML noscript that is testable in enzyme.  This is
 * needed since enzyme won't render the contents of a noscript element.
 * @param {*} props
 */
function NoScript(props) {
  if (process.env.NODE_ENV === 'test') {
    return /*#__PURE__*/_react["default"].createElement("div", props);
  } else {
    return /*#__PURE__*/_react["default"].createElement("noscript", props);
  }
}
